import { render } from "./ProjectCollection.vue?vue&type=template&id=7bd7068e"
import script from "./ProjectCollection.vue?vue&type=script&lang=js"
export * from "./ProjectCollection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/staging.tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__